export const brands = ({ brands }) => brands;
export const models = ({ models }) => models;
export const services = ({ services }) => services;
export const dealers = ({ dealers }) => dealers;
export const fetching = ({ fetching }) => fetching;
export const model = ({ model }) => model;
export const service = ({ service }) => service;
export const recomendations = ( { recomendations }) => recomendations
